import { render, staticRenderFns } from "./TissField.vue?vue&type=template&id=29a15ffe&scoped=true&"
import script from "./TissField.vue?vue&type=script&lang=js&"
export * from "./TissField.vue?vue&type=script&lang=js&"
import style0 from "./TissField.vue?vue&type=style&index=0&id=29a15ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a15ffe",
  null
  
)

export default component.exports